// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ph-1";
export var messageSideRight = "_ph-2";
export var orderLookupBubbleContainer = "_ph-0";
export var submitButton = "_ph-3";